import React from 'react'
import { Translate } from 'react-redux-i18n'
import { TextEllipsisStaticLine } from '../../../../../../../common/textEllipsis/TextEllipsisStaticLine'
import { Content } from './Content'
import { SortBySelect } from './SortBySelect'
import { YearSelect } from './YearSelect'

export const RightChart = () => {
  return (
    <div className="w50 h100 flexColumn">
      <div className="dFlex justifyContentBetween alignItemsCenter">
        <div className="flex1 fw600">
          <TextEllipsisStaticLine
            lineClamp={1}
            isI18n
            text="industryOverview.macroeconomics.IMPORT_EXPORT_PRICE"
          />
        </div>

        <div className="dFlex alignItemsCenter">
          <Translate value="industryOverview.macroeconomics.SORT_BY" />
          <SortBySelect />
          <YearSelect />
        </div>
      </div>

      <div className="flex1">
        <Content />
      </div>

      <div
        style={{ position: 'fixed', top: -1000, left: -2000, width: 1100 }}
        id="macroImportExportRightId"
      >
        <Content yAxisWidth={600} height={600} />
      </div>
    </div>
  )
}
